import React from 'react';
import { BetResponseCode, isMobile, notificationStore, TranslationKeys } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import Switcher from '../../switcher';
import {
  minOdd,
  numPadSectionName,
  autoCashOutDataKeys,
  additionalBetAmountChangingButtons,
} from '../../../../enums';
import { decidedCurrentValue } from '../../../../helpers/supporters';
import { doBetStore } from '../../../../store';
import { divide, toFixed } from '../../../../helpers/arithmeticOperations';

const AutoCashOut = ({
  t,
  maxWin,
  isActive,
  betAmount,
  activeFreeBet,
  autoCashOutOdd,
  handleOpenNumPad,
  isDisabledBetSection,
  handleSwitchAutoCashOut,
  handleChangeAutoCashOutInput,
  handleChangeAutoCashOutInputValue,
}) => {
  const { typing } = additionalBetAmountChangingButtons;

  return (
    <div className={`checkbox-wrp-item ${isDisabledBetSection}`}>
      {!isActive && (
        <p className='auto-bet-txt' title={t(TranslationKeys.AutoCashOut)}>
          {t(TranslationKeys.AutoCashOut)}
        </p>
      )}
      {isActive && (
        <div className='auto-cashout-counter'>
          <button
            type='button'
            className='auto-cashout-button'
            onClick={() => handleChangeAutoCashOutInput(AdditionalInputValueChangingButtons.minus)}
          >
            <span>
              <i className='ui-lib-minus' />
            </span>
          </button>
          <input
            type='text'
            readOnly={isMobile()}
            inputMode={isMobile() ? 'none' : 'text'}
            autoComplete='off'
            maxLength={9}
            className='auto-cashout-field'
            value={autoCashOutOdd}
            onBlur={() => {
              if (
                !autoCashOutOdd ||
                (activeFreeBet?.id && autoCashOutOdd < activeFreeBet?.minOdd) ||
                autoCashOutOdd < minOdd
              ) {
                doBetStore.updateAutoCashOutData(autoCashOutDataKeys.isValidatedOdd, true);
                doBetStore.updateAutoCashOutData(
                  autoCashOutDataKeys.autoCashOutOdd,
                  decidedCurrentValue(
                    !autoCashOutOdd ||
                      (activeFreeBet?.id && autoCashOutOdd < activeFreeBet?.minOdd) ||
                      autoCashOutOdd < minOdd,
                    activeFreeBet?.id ? activeFreeBet?.minOdd : minOdd,
                    activeFreeBet?.id ? activeFreeBet?.minOdd : minOdd,
                    notificationStore.setNotificationType,
                    BetResponseCode.InValidAutoCashOutOdd
                  )
                );
                doBetStore.updateAutoCashOutData(autoCashOutDataKeys.isBlurred, true);
              }
              if (autoCashOutOdd > divide(maxWin, betAmount)) {
                gameConfigStore.setMaxAutoCashOutOdd(toFixed(divide(maxWin, betAmount), 2));
                doBetStore.updateAutoCashOutData(autoCashOutDataKeys.isValidatedOdd, true);
                doBetStore.updateAutoCashOutData(
                  autoCashOutDataKeys.autoCashOutOdd,
                  decidedCurrentValue(
                    autoCashOutOdd < divide(maxWin, betAmount),
                    toFixed(autoCashOutOdd, 2),
                    toFixed(divide(maxWin, betAmount), 2),
                    notificationStore.setNotificationType,
                    BetResponseCode.InValidMaxAutoCashOutOdd
                  )
                );
                doBetStore.updateAutoCashOutData(autoCashOutDataKeys.isBlurred, true);
              }
            }}
            onChange={(e) => {
              if (!/^[.,]/.test(e.target.value) && /^\d*[.,]?\d*$/.test(e.target.value)) {
                handleChangeAutoCashOutInputValue(typing, e.target.value.replace(',', '.'));
              }
            }}
            {...(isMobile()
              ? { onClick: (e) => handleOpenNumPad(e, numPadSectionName.autoCashOutOdd) }
              : {})}
          />
          <button
            type='button'
            className='auto-cashout-button'
            onClick={() => handleChangeAutoCashOutInput(AdditionalInputValueChangingButtons.plus)}
          >
            <span>
              <i className='ui-lib-plus' />
            </span>
          </button>
        </div>
      )}
      <Switcher
        isActive={isActive}
        onClick={handleSwitchAutoCashOut}
        title={t(TranslationKeys.AutoCashOut)}
      />
    </div>
  );
};

export default AutoCashOut;
